import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Lightning } from "@phosphor-icons/react";
import { strengthLabel } from "./caseQuizLogic";

export const StrengthMeter = ({ score }) => {
  const label = strengthLabel(score);
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] px-3.5 py-3" data-testid="case-strength-meter" aria-live="polite">
      <div className="flex items-center justify-between text-[11px] font-semibold uppercase tracking-[0.16em]">
        <span className="inline-flex items-center gap-1.5 text-slate-400">
          <Lightning size={13} weight="fill" className="text-[var(--cf-accent)]" /> Case strength
        </span>
        <AnimatePresence mode="wait">
          <motion.span
            key={label}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.2 }}
            className="text-[var(--cf-accent)]"
            data-testid="case-strength-label"
          >
            {label}
          </motion.span>
        </AnimatePresence>
      </div>
      <div className="mt-2 h-2.5 overflow-hidden rounded-full bg-white/10">
        <motion.div
          className="cf-meter-fill h-full rounded-full bg-[var(--cf-accent)]"
          initial={false}
          animate={{ width: `${Math.max(score, 4)}%` }}
          transition={{ type: "spring", stiffness: 110, damping: 18 }}
          data-testid="case-strength-fill"
        />
      </div>
    </div>
  );
};

export const QuizProgress = ({ index, total, onBack }) => {
  const pct = Math.round(((index + 1) / total) * 100);
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onBack}
        disabled={index === 0}
        aria-label="Back"
        className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/15 text-slate-300 transition-colors duration-200 hover:bg-white/10 disabled:opacity-30"
        data-testid="case-quiz-back-button"
      >
        <span aria-hidden="true">←</span>
      </button>
      <div className="flex-1">
        <div className="mb-1.5 flex justify-between text-[11px] uppercase tracking-[0.16em] text-slate-400">
          <span data-testid="case-quiz-step-count">Step {index + 1} of {total}</span>
          <span>{pct}%</span>
        </div>
        <div className="h-1.5 overflow-hidden rounded-full bg-white/10">
          <motion.div className="h-full rounded-full bg-white" initial={false} animate={{ width: `${pct}%` }} transition={{ duration: 0.35 }} />
        </div>
      </div>
    </div>
  );
};
